export const HTML_TAGS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span',
  LABEL: 'label',
  DIV: 'div',
  UL: 'ul',
  OL: 'ol',
  LI: 'li',
  A: 'a',
  IMG: 'img',
  TABLE: 'table',
  TR: 'tr',
  TD: 'td',
  TH: 'th',
  THEAD: 'thead',
  TBODY: 'tbody',
};

// types: ['html', 'text' , 'commbobox', 'currencyInput', 'fileInput',
// 'datePicker', 'editorInput', 'maskInput', 'multipleSelect', 'numberInput', 'radioInput',
//  'select', 'textAreaInput', 'textInput', 'tickBox']

export const INPUT_TYPES = {
  TEXT: 'text',
  HTML: 'html',
  COMBOBOX: 'combobox',
  CURRENCY_INPUT: 'currencyInput',
  FILE_INPUT: 'fileInput',
  DATE_PICKER: 'datePicker',
  EDITOR_INPUT: 'editorInput',
  MASK_INPUT: 'maskInput',
  MULTIPLE_SELECT: 'multipleSelect',
  NUMBER_INPUT: 'numberInput',
  RADIO_INPUT: 'radioInput',
  TEXT_INPUT: 'textInput',
  TICK_BOX: 'tickBox',
  SELECT: 'select',
  TEXT_AREA_INPUT: 'textAreaInput',
  REPLACE: 'replace',
  WRAPPER: 'wrapper',
  TABLE: 'table',
  SIGNATURE: 'signature',
};
